import React from 'react'

function NewMessagesDivider() {
  return (
    <div className="flex items-center gap-3 my-4">
      <div className="flex-1 h-px bg-purple-300"></div>
      <span className="text-xs font-medium text-purple-600 uppercase tracking-wide">New Messages</span>
      <div className="flex-1 h-px bg-purple-300"></div>
    </div>
  )
}

export default NewMessagesDivider
